<!-- src/components/common/CookieConsentBanner.vue -->
<template>
  <div v-if="visible" class="cookie-consent-banner">
    <div class="cookie-consent-content">
      <p class="mb-2 mb-md-0">
        We use cookies to understand how you use the EDCTP Alumni Network and improve it.
        Analytics cookies are only set if you accept.
      </p>
      <div class="cookie-consent-actions">
        <button class="btn btn-outline-light btn-sm me-2" @click="decline">Decline</button>
        <button class="btn btn-light btn-sm" @click="accept">Accept</button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import AnalyticsService from '@/services/analytics/AnalyticsService'

const visible = ref(false)

onMounted(() => {
  if (AnalyticsService.isEnabled() && !AnalyticsService.hasStoredConsent()) {
    visible.value = true
  }
})

function accept() {
  AnalyticsService.grantConsent()
  visible.value = false
}

function decline() {
  AnalyticsService.denyConsent()
  visible.value = false
}
</script>

<style scoped>
.cookie-consent-banner {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1080;
  background-color: #212529;
  color: #fff;
  padding: 1rem 1.5rem;
}

.cookie-consent-content {
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
}

.cookie-consent-actions {
  display: flex;
  flex-shrink: 0;
}

@media (min-width: 768px) {
  .cookie-consent-content {
    flex-direction: row;
    align-items: center;
  }
}
</style>
